import {userDeviceId} from './UserDeviceId';

import {
    httpLikeRequestTroughWebsocket,
    makeApiServerRequest,
} from "@stores/serverConnection/makeApiServerRequest";
import {PM_ACTIONS} from "@stores/serverConnection/types";
import {WsServerConnection} from "@stores/serverConnection/wsServerConnection";


export interface NewDocFields {
    content: any;
    itemId: string;
    wsId: string;
}


export async function createDocument(wsServerConnection: WsServerConnection, docPost: NewDocFields): Promise<any> {
    return await httpLikeRequestTroughWebsocket(
        wsServerConnection,
        `d/new`,
        PM_ACTIONS.NEW_DOC,
        {
            ud: userDeviceId,
            ...docPost,
        },
        (msg) => msg.itemId,
    );
}

export interface DocUpdateInfoArchive {
    docId: string;
    archived: boolean;
}

export async function updateDocumentArchived(wsServerConnection: WsServerConnection, docUpdateInfo: DocUpdateInfoArchive): Promise<any> {
    return await httpLikeRequestTroughWebsocket(
        wsServerConnection,
        `d/archived`,
        PM_ACTIONS.ARCHIVE_DOC,
        {
            ud: userDeviceId,
            ...docUpdateInfo,
        },
        (msg) => msg.docId,
    );
}

export interface DocUpdateInfoTrashed {
    docId: string;
    trashed: boolean;
}

export async function updateDocumentTrashed(wsServerConnection: WsServerConnection, docUpdateInfo: DocUpdateInfoTrashed): Promise<any> {
    return await httpLikeRequestTroughWebsocket(
        wsServerConnection,
        `d/trashed`,
        PM_ACTIONS.TRASH_DOC,
        {
            ud: userDeviceId,
            ...docUpdateInfo,
        },
        (msg) => msg.docId,
    );
}

export async function deleteDocumentForever(wsServerConnection: WsServerConnection, docId: string): Promise<any> {
    return await httpLikeRequestTroughWebsocket(
        wsServerConnection,
        `d/delete`,
        PM_ACTIONS.DELETE_FOREVER,
        {
            docId: docId,
            ud: userDeviceId,
        },
        (msg) => msg.docId,
    );
}


export const documentSyncOn = (wsServerConnection: WsServerConnection, docId: string, docVersion: number, commentsVersion?: number) => {
    makeApiServerRequest(
        wsServerConnection,
        `d/sync`,
        {
            docId: docId,
            a: PM_ACTIONS.COLLAB_SYNC,
            ud: userDeviceId,
            dv: docVersion,
            cv: commentsVersion,
        }
    );
}

export const documentSyncOff = (wsServerConnection: WsServerConnection, docId: string) => {
    makeApiServerRequest(
        wsServerConnection,
        `d/close`,
        {
            docId: docId,
        },
    );
}

export const getDocumentFromServer = (wsServerConnection: WsServerConnection, docId: string, abortController?: AbortController) => {
    return httpLikeRequestTroughWebsocket(
        wsServerConnection,
        `d/get`,
        PM_ACTIONS.COLLAB_GET_DOCUMENT,
        {
            docId: docId,
        },
        msg => msg.docId,
        abortController
    );
}

export const sendEvents = async (wsServerConnection: WsServerConnection, docId: string, payload: any) => {
    return await httpLikeRequestTroughWebsocket(
        wsServerConnection,
        `d/events`,
        PM_ACTIONS.COLLAB_SEND_EVENTS,
        {
            docId: docId,
            ...payload,
        },
        (msg) => msg.docId,
    );
}

export const sendSelection = (wsServerConnection: WsServerConnection, docId: string, payload: any) => {
    return makeApiServerRequest(
        wsServerConnection,
        `d/s`,
        {
            a: PM_ACTIONS.COLLAB_SYNC_SELECTION,
            docId: docId,
            ...payload,
        },
    );
}

export const getEvents = async (wsServerConnection: WsServerConnection, docId: string, payload: any, abortController?: AbortController)=> {
    return await httpLikeRequestTroughWebsocket(
        wsServerConnection,
        `d/events`,
        PM_ACTIONS.COLLAB_GET_EVENTS,
        {
            docId: docId,
            v: payload.version,
        },
        (msg) => msg.docId,
        abortController,
    );
}

export const getSnapshots = async (wsServerConnection: WsServerConnection, docId: string, abortController?: AbortController)=> {
    return await httpLikeRequestTroughWebsocket(
        wsServerConnection,
        `s/l`,
        PM_ACTIONS.SNAPSHOT_LIST,
        {
            d: docId,
        },
        (msg) => msg.d,
        abortController,
    );
}

export const getSnapshot = async (wsServerConnection: WsServerConnection, docId: string, timestamp: number, abortController?: AbortController)=> {
    return await httpLikeRequestTroughWebsocket(
        wsServerConnection,
        `s/g`,
        PM_ACTIONS.SNAPSHOT_GET,
        {
            d: docId,
            t: timestamp,
        },
        (msg) => `${msg.d}#${msg.t}`,
        abortController,
    );
}

export const restoreSnapshot = async (wsServerConnection: WsServerConnection, docId: string, timestamp: number, abortController?: AbortController)=> {
    return await httpLikeRequestTroughWebsocket(
        wsServerConnection,
        `s/re`,
        PM_ACTIONS.SNAPSHOT_RESTORE,
        {
            d: docId,
            t: timestamp,
            ud: userDeviceId,
        },
        (msg) => `${msg.d}#${msg.t}`,
        abortController,
    );
}

export const forceSave = async (wsServerConnection: WsServerConnection, docId: string, content: string, abortController?: AbortController)=> {
    return await httpLikeRequestTroughWebsocket(
        wsServerConnection,
        `s/fs`,
        PM_ACTIONS.SNAPSHOT_FORCE_SAVE,
        {
            d: docId,
            content: content,
            ud: userDeviceId,
        },
        (msg) => `${msg.d}`,
        abortController,
    );
}

export const saveAsSnapshot = async (wsServerConnection: WsServerConnection, docId: string, content: string, abortController?: AbortController)=> {
    return await httpLikeRequestTroughWebsocket(
        wsServerConnection,
        `s/save_as`,
        PM_ACTIONS.SNAPSHOT_SAVE_AS,
        {
            d: docId,
            content: JSON.stringify(content),
            ud: userDeviceId,
        },
        (msg) => `${msg.d}`,
        abortController,
    );
}
